export default from './TemplateTag';
